import { createContext, useCallback, useState, useContext } from "react";
import React from "react";
import Api from "../adapters/api/api";
import { AuthenticationMemo } from "../core/AuthenticationMemo/AuthenticationMemo";

interface ISignInCredential {
  user: string;
  password: string;
}

interface IAuthContext {
  user: object;
  signIn(credential: ISignInCredential): Promise<void>;
  SignOut(): void;
}

interface IAuthState {
  token: string;
  user: Object;
}

const AuthContext = createContext<IAuthContext>({} as IAuthContext);

export const AuthProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [data, setData] = useState<IAuthState>(() => {
    const token = localStorage.getItem("@showmusic:token");
    const user = localStorage.getItem("@showmusic:user");

    if (token && user) {
      return { token, user: JSON.parse(user) };
    }
    return {} as IAuthState;
  });

  const signIn = useCallback(async ({ user, password }: ISignInCredential) => {
    const response = await Api.post("/admin/user/login", {
      user,
      password,
    });

    const { token } = response.data;
    AuthenticationMemo.signIn(token, {});
    setData({ token, user });
  }, []);

  const SignOut = useCallback(() => {
    AuthenticationMemo.SignOut();
    setData({} as IAuthState);
  }, []);

  return (
    <AuthContext.Provider value={{ user: data.user, signIn, SignOut }}>
      <>{children}</>
    </AuthContext.Provider>
  );
};

export function useAuth(): IAuthContext {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
